import { setTheme } from "theme/default/setTheme";

export const setBackgroundColor_93a5b8 = setTheme(({ theme }) => `background-color: ${theme.colors.color_93a5b8}`);
